import React from 'react';
import { Typography, Paper } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useTenant } from '../../contexts/TenantContext';
import ResponsiveLayout from './ResponsiveLayout';

/**
 * Short-circuits all app content to a friendly "feature pending" banner for
 * users whose role is flagged with LISTING_ACCESS_PENDING. Today that's the
 * Ocusell Personal Assistant (PA) class — the delegated-agent flow is a
 * future chapter, so we keep them out of the app and tell them to check with
 * their administrator.
 *
 * RESO never emits LISTING_ACCESS_PENDING, so Bright is unaffected.
 */
const ListingAccessPendingGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isListingAccessPending } = useAuth();
  const { tenant } = useTenant();

  if (!isListingAccessPending()) {
    return <>{children}</>;
  }

  const tenantLabel = tenant ? `${tenant} ` : '';

  return (
    <ResponsiveLayout>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          maxWidth: 600,
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ color: 'secondary.medium' }}
        >
          Hello, {tenantLabel}Personal Assistant
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          We&apos;re working hard on this feature. Please check with your
          administrator for listing management access.
        </Typography>
      </Paper>
    </ResponsiveLayout>
  );
};

export default ListingAccessPendingGate;
